import styled, { css } from "styled-components";
import { Button, ModalFooter } from "react-bootstrap";

interface ChangedProps {
    isDragActive: boolean;
    isDragReject: boolean;
}

const dragActive = css`
    border-color: #78e5d5;
`;

const dragReject = css`
    border-color: #e57878;
`;

const StyledTitle = styled.h1`
    font-weight: 700;
    font-size: 36px;
    line-height: 130%;
    display: flex;
    align-items: center;
    margin: 0;
    mix-blend-mode: normal;
`;

const StyledImportTitle = styled.h1`
    font-family: Verdana;
    font-weight: 700;
    font-size: 36px;
    line-height: 130%;
    display: flex;
    align-items: center;
    margin: 0;
    mix-blend-mode: normal;
`;

const StyledSubTitle = styled.h3`
    font-size: 17px;
    line-height: 21px;
    color: #383838;
    padding-bottom: 16px;
    margin: 0px;
    margin-top: 1rem;
`;

const StyledImportSubTitle = styled.h3`
    font-size: 17px;
    line-height: 21px;
    color: #8a0538;
    padding-bottom: 16px;
    margin: 0px;
    margin-top: 0.5rem;
`;

const StyledContainerHeader = styled.div`
    margin-top: 34px;
    padding-left: 10px;
`;

const StyledContainerBody = styled.div`
    padding-top: 0;
    padding-left: 10px;
`;

const StyledContainerDropzone = styled.div<{ height?: number }>`
    height: ${({ height }) => (height ? `${height}px` : `290px`)};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

const StyledDropContainer = styled.div.attrs<ChangedProps>({
    className: "dropzone",
})`
    border: 1px solid #787878;
    border-radius: 4px;
    cursor: pointer;
    height: 100%;
    border-radius: 4px;

    transition: height 0.2s ease;

    ${(props: ChangedProps) => props.isDragActive && dragActive}
    ${(props: ChangedProps) => props.isDragReject && dragReject}
`;

const StyledDropzoneTitle = styled.h2`
    color: #404040;
    font-weight: 400;
    font-size: 17px;
    line-height: 21px;
    text-align: center;
`;

const StyledDropzoneButton = styled(Button)`
    width: 193px;
    height: 48px;
    background: #8a0538;
    border-radius: 24px;
    border: 1px solid #8a0538;
    cursor: none;
    &:hover {
        background-color: #570013 !important;
        border-color: #570013 !important;
    }
`;

const StyledDropzoneParagraph = styled.p`
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    color: #dd0606;
    margin: 0;
    margin-left: 16px;
`;

const StyledDropzoneError = styled.div`
    display: flex;
    align-items: center;
    height: 43px;
    background: #f8d7da;
    border: 1px solid #dd0606;
    border-radius: 0px 0px 4px 4px;
    width: 100.4%;
    margin-left: -1px;
    margin-top: -3px;
`;

const StyledFileInformationDiv = styled.div`
    display: flex;
    border: 1px solid #f5f5f5;
    border-radius: 8px;
    padding: 1em;
`;

const StyledDownloadButton = styled(Button)`
    width: 134px;
    height: 48px;
    padding: 12px, 32px;
    margin-left: 20px;
    background: #8a0538;
    border: 1px solid #8a0538;
    border-radius: 24px;
    font-size: 16px;
    > a {
        color: #787878;
        text-decoration: inherit;
    }
    &:disabled {
        background: #f5f5f5;
        border: 1px solid #787878;
        color: #787878;
    }
    &:hover {
        background: #570013 !important;
        border: 1px solid #570013 !important;
    }
`;

const StyledImportButton = styled(Button)`
    width: 112px;
    height: 48px;
    font-size: 16px;
    background: #8a0538;
    border: 1px solid #8a0538;
    border-radius: 24px;
    > a {
        color: inherit;
        text-decoration: inherit;
    }
    &:disabled {
        background: #e4e4e4;
        border: 1px solid #e4e4e4;
        color: #404040;
    }
    &:hover {
        background: #570013 !important;
        border: 1px solid #570013 !important;
    }
`;

const StyledDefaultButton = styled(Button)`
    font-size: 16px;
    width: 112px;
    height: 48px;
    background: #fff;
    border: 1px solid #8a0538;
    border-radius: 24px;
    color: #8a0538;
    &.btn:first-child:hover {
        background: #570013;
        border: 1px solid #570013;
    }
    > a {
        color: inherit;
        text-decoration: inherit;
    }
    &:disabled {
        background: #e4e4e4;
        border: 1px solid #e4e4e4;
        color: #404040;
    }
    &:hover {
        background: #570013 !important;
        border: 1px solid #570013 !important;
    }
    &.btn:focus {
        background: #8a0538;
        border: 1px solid #8a0538;
    }
    &.btn:active {
        background: #8a0538;
        border: 1px solid #8a0538;
    }
`;

const StyledModalText = styled.h4`
    font-weight: 400;
    font-size: 17px;
    line-height: 150%;
    padding: 24px 0px;
`;

const StyledModalTitle = styled.h4`
    font-weight: 700;
    font-size: 24px;
    line-height: 130%;
    color: #1e1e1e;
`;

const StyledModalFooter = styled(ModalFooter)`
    border-top: none;
    justify-content: center;
`;

const StyledModalFooterLink = styled.a`
    font-size: 16px;
    line-height: 100%;
    text-decoration: none;
    color: #8a0538;
    cursor: pointer;
    &:hover {
        color: #9654ff;
    }
`;

const StyledParagraph = styled.p`
    margin: 50px;
`;

const StyledFileName = styled.p`
    color: #1e1e1e;
    font-size: 15px;
    margin: 0 15px;
`;

const StyledFileSize = styled.p`
    color: #787878;
    font-size: 13px;
    margin: 1.5px 0 0 15px;
`;

const StyledHr = styled.hr`
    width: 912px;
    color: #d9d9d9;
    margin: 20px 20px 30px 0;
`;

const StyledFileContainer = styled.div`
    max-width: 860px;
    display: flex;
    justify-content: space-between;
`;

export default {
    StyledTitle,
    StyledImportTitle,
    StyledSubTitle,
    StyledImportSubTitle,
    StyledParagraph,
    StyledFileName,
    StyledFileSize,
    StyledModalText,
    StyledModalTitle,
    StyledModalFooter,
    StyledFileInformationDiv,
    StyledDownloadButton,
    StyledImportButton,
    StyledDefaultButton,
    StyledDropzoneTitle,
    StyledContainerBody,
    StyledDropContainer,
    StyledContainerDropzone,
    StyledDropzoneError,
    StyledDropzoneButton,
    StyledContainerHeader,
    StyledModalFooterLink,
    StyledDropzoneParagraph,
    StyledHr,
    StyledFileContainer,
};
